// Write your code here
import './index.css'

const SuggestionItem = props => {
  const {suggestionText, selectSuggestion} = props
  const clickArrow = () => {
    selectSuggestion(suggestionText)
  }

  return (
    <li>
      <p className="text">{suggestionText}</p>
      <img
        src="https://assets.ccbp.in/frontend/react-js/diagonal-arrow-left-up.png"
        alt="arrow"
        className="arrow"
        onClick={clickArrow}
      />
    </li>
  )
}

export default SuggestionItem
